import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DocumentsFeature } from './selectors';
import { UploadingDocumentVersionData } from './state';
import {
  BatchUpdateDocumentDto,
  CreateDocumentDto,
  DocumentCommonDto,
  GetDocumentDto,
  GetDocumentDtoExtended,
} from '../models/documents.model';
import { SendReportDto } from 'src/app/shared/services/reporting-api.service';
import type { DocumentProcessingPagedReviewResponse } from '../services/document-processing-api.service';

export const DocumentsActions = createActionGroup({
  source: DocumentsFeature,
  events: {
    'Get Documents': emptyProps(),
    'Load Documents Fail': emptyProps(),
    'Load Documents': emptyProps(),
    'Set Documents': props<{ documents: GetDocumentDtoExtended[] }>(),
    'Upload Selected Document File': props<{ file: File; requestKey: string }>(),
    'Upload Selected Document File Success': props<{ fileId: string; requestKey: string }>(),
    'Upload Selected Document File Fail': props<{ errorMessage: string; requestKey: string }>(),
    'Clear Selected Document File Upload': emptyProps(),
    'Create Document': props<{ model: CreateDocumentDto }>(),
    'Create Document Success': props<{ document: GetDocumentDto }>(),
    'Create Document Fail': props<{ document: CreateDocumentDto }>(),
    'Start Uploading Document Version': props<{ data: UploadingDocumentVersionData }>(),
    'Complete Uploading Document Version': emptyProps(),
    'Create Document Cancel': props<{ pristine: boolean }>(),
    'Create Document Cancelled': emptyProps(),
    'Clear Create Document Cancelled': emptyProps(),
    'Close Creating Document Modal': emptyProps(),
    'Download Document': props<{ uniqueId: string; fileName: string }>(),
    'Download Document Success': emptyProps(),
    'Download Document Fail': emptyProps(),
    'Delete Document': props<{ uniqueId: string }>(),
    'Delete Document Confirmed': props<{ uniqueId: string }>(),
    'Delete Document Success': emptyProps(),
    'Delete Document Fail': emptyProps(),
    'Delete Document Cancel': emptyProps(),
    'Update Documents': props<{ documents: BatchUpdateDocumentDto[] }>(),
    'Update Documents Success': emptyProps(),
    'Update Documents Fail': emptyProps(),
    'Delete Documents': props<{ uniqueIds: string[] }>(),
    'Delete Documents Confirmed': props<{ uniqueIds: string[] }>(),
    'Delete Documents Success': emptyProps(),
    'Delete Documents Fail': emptyProps(),
    'Delete Documents Cancel': emptyProps(),
    'Load Document': props<{ uniqueId: string }>(),
    'Load Document Fail': emptyProps(),
    'Set Document': props<{ document: GetDocumentDto }>(),
    'Edit Document': props<{ model: DocumentCommonDto; uniqueId: string; closeOnSuccess?: boolean }>(),
    'Edit Document Success': props<{ document: GetDocumentDto; closeOnSuccess?: boolean }>(),
    'Edit Document Fail': emptyProps(),
    'Edit Document Cancel': props<{ pristine: boolean }>(),
    'Edit Document Cancelled': emptyProps(),
    'Clear Edit Document Cancelled': emptyProps(),
    'Close Editing Document Modal': emptyProps(),
    'Send Report': props<{ report: SendReportDto; doc: GetDocumentDto }>(),
    'Send Report Started': emptyProps(),
    'Send Report Complete Success': emptyProps(),
    'Send Report Complete Failed': emptyProps(),
    'Start Asking Report Status': emptyProps(),
    'Send Report Cancel': props<{ pristine: boolean }>(),
    'Send Report Cancelled': emptyProps(),
    'Clear Send Report Cancelled': emptyProps(),
    'Close Sending Report Modal': emptyProps(),
    'Set Selected Document Playbook': props<{ uniqueId: string; assignedPlaybookId: string | null }>(),
    'Start Page Review': props<{ documentUniqueId: string; assignedPlaybookId: string }>(),
    'Page Review Started': props<{ documentUniqueId: string }>(),
    'Page Review Page Loaded': props<{
      documentUniqueId: string;
      pagedReviewData: DocumentProcessingPagedReviewResponse;
    }>(),
    'Page Review Complete': props<{ documentUniqueId: string }>(),
    'Page Review Fail': props<{ documentUniqueId: string }>(),
  },
});
